import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem } from '@material-ui/core';

import RoleValidator from '../RoleValidator';
import Select from '../Select';

/**
 * A reusable role-gated dropdown used in page headers for switching context
 * (e.g. Group, Region, Location). Renders nothing when the list is empty or
 * when the optional `condition` guard is false.
 */
const DropdownFilter = ({
  roles,
  condition = true,
  list,
  value,
  label,
  idKey,
  nameKey,
  onSelect,
  disabled = false,
  testIdPrefix,
  className = 'medium-width',
  id,
  fullWidth = false,
}) => {
  if (!condition || !list.length) return null;

  const labelId = id ? `${id}-label` : undefined;

  return (
    <RoleValidator roles={roles}>
      <FormControl variant="outlined" className={className} disabled={disabled} fullWidth={fullWidth}>
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          id={id}
          labelId={labelId}
          label={label}
          value={value || ''}
          fullWidth={fullWidth}
          onChange={(e) => {
            const selected = list.find((item) => item[idKey] === e.target.value);
            onSelect(selected);
          }}
        >
          {list.map((item, index) => (
            <MenuItem
              key={item[idKey]}
              value={item[idKey]}
              data-testid={`${testIdPrefix}-${index}`}
            >
              {item[nameKey]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </RoleValidator>
  );
};

DropdownFilter.propTypes = {
  roles: PropTypes.array.isRequired,
  condition: PropTypes.bool,
  list: PropTypes.array.isRequired,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  idKey: PropTypes.string.isRequired,
  nameKey: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  testIdPrefix: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default DropdownFilter;
